import React from 'react';
import styled from 'styled-components';
import { combineClassNames } from '../../utils/base';
import { SeparatorComponent } from '../../types/base';
import generateComponentStyles from '../../utils/styleHelper';

const StyledSeparator = styled.div<{
  $shape?: any;
  $parentDisplay?: string;
  $parentFlexDirection?: string;
  type?: string;
}>`
  ${(props) => generateComponentStyles(props.$shape, undefined, undefined, props.$parentDisplay, undefined, props.$parentFlexDirection)}
  /* Add specific styling for the separator */
  z-index: 1;
  border: ${(props) => (props.type === 'line' ? '1px solid black' : 'none')};
`;

const Separator: React.FC<SeparatorComponent & { parentStyle?: any }> = ({
  id, type, title, style, parentStyle,
}) => (
  <StyledSeparator
    id={id}
    type={type}
    $shape={style}
    $parentDisplay={parentStyle?.display}
    $parentFlexDirection={typeof parentStyle?.flex === 'object' ? parentStyle?.flex?.direction : undefined}
    className={combineClassNames(style.class)}
  >
    {title}
  </StyledSeparator>
);

export default Separator;
